// Submit the form.
document.addEventSelectorListener("input", "input[data-on-change='submit']", function(event, target) {
	const form = target.closest("form");
	form.trigger("submit");
});

// Show value of the range slider.
document.addEventSelectorListener("input", "input[data-on-input]", function(event, input) {
	const value = input.value;
	const formattedValue = value.replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " Kč";

	for (let element of document.querySelectorAll(input.getAttribute("data-on-input"))) {
		element.textContent = formattedValue;
	}
});
